import { SearchTerm } from './SearchTerm';

const ReportSearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "trnName",
        translationKey: "name"
    },
    {
        heading: "Site",
        accessor: "site",
        searchOnName: "userLogin.site.siteName",
        translationKey: "site"
    },
    // {
    //     heading: "Type",
    //     accessor: "type",
    //     searchOnName: "reportType.trnName",
    //     translationKey: "type"
    // },
];

export default ReportSearch;
